/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './error-page.css';
import Title from '../../component/title/Title';
import { PrimaryButton, SecondaryButton, ErrorPageRedirectButton } from '../../component/buttonComponent/ButtonComponent';
import peep404 from '../../image/shaun.svg';
import peep500 from '../../image/farhan.svg';
import peep403 from '../../image/melissa.svg';

export default function BrokenPage({ resetErrorBoundary }) {
    const navigate = useNavigate();

    function getWindowSize() {
        const { innerWidth, innerHeight } = window;
        return { innerWidth, innerHeight };
    }
    const [windowSize, setWindowSize] = useState(getWindowSize());

    function handleWindowResize() {
        setWindowSize(getWindowSize());
    }

    const navigateBack = (e) => {
        e.preventDefault();
        navigate(-1);
        // Clear the boundary's error state so the destination re-mounts even when
        // the target path matches the current one (resetKeys alone can't catch that).
        resetErrorBoundary?.();
    };

    const navigateDashboard = (e) => {
        e.preventDefault();
        navigate('/dashboard', { replace: true });
        resetErrorBoundary?.();
    };

    useEffect(() => {
            window.addEventListener('resize', handleWindowResize);
            return () => {
                window.removeEventListener('resize', handleWindowResize);
            };
    }, []);

    function populateErrorObject() {
        const updatedValue = {
            code: '500 error',
            title: 'Unexpected error',
            subtitle: 'Yikes, this is our bad! Our engineers have been notified and will begin exterminating the bugs.',
            peep: peep500,
            peepWidth: '29.688rem',
            peepHeight: '40.063rem',
        };
        return updatedValue;
    }

    return (
        // <div className="error-page-container-main">
            <div className="error-page-container" style={{ height: windowSize.innerHeight, width: windowSize.innerWidth }}>
                <div className="error-page-left-content">
                    <div className="error-page-header">
                        <div className="error-page-heading">
                            {populateErrorObject().code}
                        </div>
                        <Title
                          title={populateErrorObject().title}
                          subtitle={populateErrorObject().subtitle}
                          titleSize="3.75rem"
                          subtitleSize="1.25rem"
                          gap="2rem"
                          subtitleLineHeight="1.875rem"
                        />
                    </div>
                    <div className="error-page-buttons">
                        <SecondaryButton label="Go back" width="8.25rem" imageIcon="Back" onClickFunction={navigateBack} />
                        <PrimaryButton label="Country roads, take me home..." width="17.625rem" onClickFunction={navigateDashboard} />
                    </div>
                    <div className="error-page-resources">
                        <ErrorPageRedirectButton label="Documentation" description="Dive in to learn all about our product." />
                        <ErrorPageRedirectButton label="Our blog" description="Read the latest posts on our blog." />
                        <ErrorPageRedirectButton label="Contact support" description="Our friendly team is here to help." />
                    </div>
                </div>
                <div className="error-page-right-content">
                    <div className="error-page-image-container">
                        <img loading="lazy" src={populateErrorObject().peep} className="error-page-image" alt="peep" style={{ width: populateErrorObject().peepWidth, height: populateErrorObject().peepHeight }} />
                    </div>

                </div>
            </div>
        // </div>
    );
}
